import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import type { CurrentCommunity } from "@/react/types/CurrentCommunity";

interface ErrorPageBrandV4Props {
  brandColor?: string;
  communityUrl: string;
  currentCommunity?: CurrentCommunity;
  logoUrl: string;
}

export const ErrorPageBrandV4 = ({
  brandColor,
  communityUrl,
  currentCommunity,
  logoUrl,
}: ErrorPageBrandV4Props) => (
  <a aria-label={t("error_page.v4.back_to_homepage")} href={communityUrl}>
    <div className="bg-secondary flex size-20 items-center justify-center rounded-full">
      {logoUrl ? (
        <img
          alt={
            currentCommunity
              ? t("error_page.v4.community_logo", {
                  communityName: currentCommunity.name,
                })
              : ""
          }
          className="size-auto max-h-12 max-w-12 object-contain"
          src={logoUrl}
        />
      ) : (
        <div
          className="flex size-12 items-center justify-center rounded-full"
          style={{ backgroundColor: brandColor }}
        >
          <Typography variant="heading-md" color="primary">
            {currentCommunity?.name?.[0]}
          </Typography>
        </div>
      )}
    </div>
  </a>
);
